import React from "react";
import PropTypes from "prop-types";
import { Route, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Translate } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import Layout from "../../Layouts/LayoutMain";
import { ContentContainer } from "../../Components/Common/ContentContainer";
import CustomerInfo from "./CustomerInfo";
import CustomerAddresses from "./CustomerAddresses";
import CustomerOrders from "./CustomerOrders";
import CustomerPassword from "./CustomerPassword";

function Customer(props) {
    const { isAuthenticated, userInfo } = props;

    return (
        <Layout isAuthenticated={isAuthenticated}>
            <ContentContainer>
                <div className="row">
                    <div className="col-lg-4">
                        <div className="boxed boxed--lg boxed--border">
                            <div className="text-block text-center">
                                {/* <img alt="avatar" src={userInfo.picture} className="image--sm" />*/}
                                <span className="h5">{userInfo.firstName} {userInfo.lastName}</span>
                                <span>{userInfo.companyName}</span>
                            </div>
                            <hr/>
                            <div className="text-block">
                                <ul className="menu-vertical">
                                    <li>
                                        <Link to={Constants.ENDPOINTS.CUSTOMER_INFO} ><Translate value="profile.info.title" /></Link>
                                    </li>
                                    {/* <li>
                                        <Link to={Constants.ENDPOINTS.CUSTOMER_ADDRESSES} ><Translate value="profile.addresses.title" /></Link>
                                    </li>
                                    <li>
                                        <Link to={Constants.ENDPOINTS.CUSTOMER_ORDERS} ><Translate value="profile.orders.title" /></Link>
                                    </li>*/}
                                    <li>
                                        <Link to={Constants.ENDPOINTS.CUSTOMER_CHANGE_PASSWORD} ><Translate value="profile.changePassword.title" /></Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        <div className="boxed boxed--lg boxed--border">
                            <Route path={Constants.ENDPOINTS.CUSTOMER_INFO} component={CustomerInfo}/>
                            {/* <Route path={Constants.ENDPOINTS.CUSTOMER_ADDRESSES} component={CustomerAddresses}/>
                            <Route path={Constants.ENDPOINTS.CUSTOMER_ORDERS} component={CustomerOrders}/>*/}
                            <Route path={Constants.ENDPOINTS.CUSTOMER_CHANGE_PASSWORD} component={CustomerPassword}/>
                        </div>
                    </div>
                </div>
            </ContentContainer>
        </Layout>
    );
}

Customer.propTypes = {
    isAuthenticated: PropTypes.bool,
    i18n: PropTypes.object,
    config: PropTypes.object,
    userInfo: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Customer);
